export default {
    parts: [
        'container',
        'CtaItemBlockPreTitleStyle',
        'CtaItemBlockTitleStyle',
        'CtaItemBlockDescriptionStyle',
        'CtaItemBlockDescriptionStyle',
        'cta',
        'link',
        'ctaText'
    ],
    baseStyle: (props) => ({
        container: {
            position: props?.position,
            zIndex: '1',

            // Icon With Text styling - card style with background
            ...(props?.Styling === 'Icon With Text' && {
                backgroundColor: props?.CTABackgroundColor || 'transparent',
                padding: props?.noPadding ? 0 : { base: 4, lg: 6 },
                borderRadius: 0,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                // Vertical alignment from Alignment prop (first part: top/center/bottom)
                justifyContent: props?.Alignment?.startsWith('top') ? 'flex-start' :
                    props?.Alignment?.startsWith('bottom') ? 'flex-end' :
                    props?.Alignment?.startsWith('center') ? 'center' : 'flex-start',
                // Horizontal alignment from Alignment prop (second part: left/center/right)
                alignItems: props?.Alignment?.endsWith('left') ? 'flex-start' :
                    props?.Alignment?.endsWith('right') ? 'flex-end' :
                    props?.Alignment?.endsWith('center') ? 'center' : 'flex-start',
                // Text alignment follows horizontal alignment
                textAlign: props?.Alignment?.endsWith('left') ? 'left' :
                    props?.Alignment?.endsWith('right') ? 'right' :
                    props?.Alignment?.endsWith('center') ? 'center' : 'left'
            }),

            // Default or bottom/left alignment
            ...((props?.Alignment === "" || props?.Alignment === "bottom/left") && props?.position !== 'static' && {
                bottom: { base: 0 },
                left: { base: 0 },
                textAlign: { base: 'left' },
                padding: { base: 4 }
            }),

            /* bottom/center */
            ...(props?.Alignment === "bottom/center" && props?.position !== 'static' && {
                bottom: { base: 0 },
                left: { base: '50%' },
                transform: { base: 'translateX(-50%)' },
                textAlign: { base: 'center' },
                padding: { base: '4' },
            }),

            /* bottom/right */
            ...(props?.Alignment === "bottom/right" && props?.position !== 'static' && {
                bottom: { base: 0 },
                right: { base: 0 },
                textAlign: { base: 'right' },
                padding: { base: 4 },
            }),

            /* center/right */
            ...(props?.Alignment === "center/right" && props?.position !== 'static' && {
                top: { base: '50%' },
                right: { base: 0 },
                transform: { base: 'translate(0, -50%)' },
                textAlign: { base: 'right' },
                padding: { base: '4' },
            }),

            /* top/right */
            ...(props?.Alignment === "top/right" && props?.position !== 'static' && {
                top: { base: 0 },
                right: { base: 0 },
                textAlign: { base: 'right' },
                padding: { base: '4' },
            }),

            /* top/center */
            ...(props?.Alignment === "top/center" && props?.position !== 'static' && {
                top: { base: 0 },
                left: { base: '50%' },
                transform: { base: 'translate(-50%, 0)' },
                textAlign: { base: 'center' },
            }),

            /* top/left */
            ...(props?.Alignment === "top/left" && props?.position !== 'static' && {
                top: { base: 0 },
                left: { base: 0 },
                textAlign: { base: 'left' },
                padding: { base: '4' },
            }),

            /* center/center */
            ...(props?.Alignment === 'center/center' && props?.position !== 'static' && {
                textAlign: { base: 'center' },
                top: { base: '50%' },
                left: { base: '50%' },
                transform: { base: 'translate(-50%, -50%)' },
            }),

            width: props?.CtaItemBlockWidth && props?.CtaItemBlockWidth !== '' ? props?.CtaItemBlockWidth : 'max-content',
            maxWidth: '100%',

            // Static position alignment (for normal flow, non-absolute positioning)
            ...(props?.position === 'static' && {
                ...(props?.Styling?.toLowerCase() === 'text' && {
                    display: 'flex',
                    // Vertical alignment from Alignment prop (before /: left/center/right)
                    // Using alignItems for vertical alignment
                    alignItems: props?.Alignment?.startsWith('top') ? 'flex-start' :
                        props?.Alignment?.startsWith('bottom') ? 'flex-end' :
                        props?.Alignment?.startsWith('center') ? 'center' : 'flex-start',
                    // Horizontal alignment from Alignment prop (after /: left/center/right)
                    // Using justifyContent for horizontal alignment
                    justifyContent: props?.Alignment?.endsWith('left') ? 'flex-start' :
                        props?.Alignment?.endsWith('right') ? 'flex-end' :
                        props?.Alignment?.endsWith('center') ? 'center' : 'flex-start',
                }),
                // Horizontal alignment from Alignment prop (after /: top/center/bottom)
                // Horizontal is done via margins
                marginLeft: props?.Alignment?.endsWith('center') ? 'auto' :
                    props?.Alignment?.endsWith('right') ? 'auto' : undefined,
                marginRight: props?.Alignment?.endsWith('center') ? 'auto' :
                    props?.Alignment?.endsWith('left') ? 'auto' : undefined,
                // Text alignment follows horizontal alignment
                textAlign: props?.Alignment?.endsWith('left') ? 'left' :
                    props?.Alignment?.endsWith('right') ? 'right' :
                    props?.Alignment?.endsWith('center') ? 'center' : 'left'
            })
        },
        CtaItemBlockPreTitleStyle: {
            fontSize: { base: 'xs' },
            lineHeight: { base: '120%' },
            marginBottom: { base: 2 }
        },
        CtaItemBlockTitleStyle: {
            fontSize: { base: '32px ' },
            lineHeight: { base: '120%' },
            fontWeight: { base: 'bold' },
            marginBottom: { base: 4, lg: 3 },
            ...(props?.TitleShadowEffect && {
                textShadow: '0px 4px 13px rgb(0 0 0 / 0.5)'
            }),
            ...(props?.Styling === 'Icon With Text' && {
                fontSize: { base: 'lg', lg: 'xl' },
                lineHeight: { base: '120%' },
                marginBottom: { base: 3 }
            })
        },
        CtaItemBlockDescriptionStyle: {
            fontSize: { base: 'md ' },
            lineHeight: { base: '140%' },
            marginBottom: { base: 4 },
            ...(props?.Styling === 'Icon With Text' && {
                fontSize: { base: 'sm', lg: 'md' },
                lineHeight: { base: '140%' },
                marginBottom: { base: 0 }
            })
        },
        cta: {
            fontSize: { base: 'sm', lg: 'md' },
            lineHeight: { base: '100%'},
            letterSpacing: { base: '2%' },
            paddingLeft: { base: 8, lg: 10 },
            paddingRight: { base: 8, lg: 10 },
            paddingTop: {base: 1, lg: 1},
            paddingBottom: {base: 1, lg: 1},
            height: { base: 'auto' },
            minHeight: { base: '42px' },
            cursor: { base: 'pointer' },
            backgroundColor: { base: props?.CTABackgroundColor || 'black' },
            color: { base: props?.TextColor || 'white' },
            textDecoration: { base: props?.Underline ? 'underline' : 'none' },
            letterSpacing: '0%',
            ...(props?.Styling === 'Outlined' && {
                backgroundColor: { base: props?.CTABackgroundColor && props?.CTABackgroundColor !== '' ? props?.CTABackgroundColor : 'transparent' },
            }),
            _hover: {
                textDecoration: { base: 'none' }
            },
        },
        link: {
            fontSize: { base: 'sm', lg: 'md' },
            lineHeight: { base: '120%' },
            fontWeight: { base: 'bold' },
            color: { base: props?.TextColor || 'black' },
            textDecoration: { base: props?.Underline ? 'underline' : 'none' },
            _hover: {
                color: { base: props?.TextColor || 'black' }
            }
        },
        linkWithText: {
            fontSize: { base: 'sm', lg: 'md' },
            lineHeight: { base: '120%' },
            fontWeight: { base: 'bold' },
            color: { base: props?.TextColor || 'black' },
            textDecoration: { base: props?.Underline ? 'underline' : 'none' },
            marginLeft: { base: 1 },
            marginRight: { base: 1 },
            _hover: {
                color: { base: props?.TextColor || 'black' }
            }
        },
        popoverContent: {
            width: {base: '100%'},
            maxWidth: {base: '342px'},
            borderRadius: {base: 0},
            padding: {base: '8px'},
            maxHeight: {base: '377px'},
            overflow: {base: 'auto'}
        },
        popoverBody: {
            padding: 0
        }
    }),
    variants: {
        'Icon With Text': (props) => ({
            container: {
                // Background color is handled in baseStyle
                width: '100%'
            }
        }),
        'Button': (props) => ({
            cta: {
                _hover: {
                    backgroundColor: 'charcoal',
                    color: 'white'
                },
                _active: {
                    backgroundColor: 'charcoal',
                    color: 'white'
                },
                '@supports (-webkit-appearance: none) and (stroke-color: transparent)': {
                    paddingTop: 1,
                    paddingBottom: 1
                },
                // For macOS Chrome
                '.is-mac-chrome &': {
                    paddingTop: '0',
                    paddingBottom: '0'
                }
            },
            ctaText: {
                lineHeight: '0',
                paddingTop: '0.25em',
                paddingBottom: '0.5em',
                // Safari
                ...(props?.isSafari && {
                    paddingTop: '0.55em',
                    paddingBottom: '0.20em'
                }),
                // Safari on iOS
                ...(props?.isSafari && props?.isIOS && {
                    paddingTop: '0.6em',
                    paddingBottom: '0.20em'
                }),
                // Other browsers except Safari on ioOS and macOS or android
                ...(((!props?.isSafari && (props?.isIOS || props?.isMacOS)) || props?.isAndroid) && {
                    paddingTop: '0.4em',
                    paddingBottom: '0.4em'
                }),
                // MacOS and Chrome
                ...(props?.isMacOSChrome && {
                    paddingTop: '0.5em',
                    paddingBottom: '0.36em'
                })
            }
        }),
        'Outlined':  (props) => ({
            cta: {
                _hover: {
                    backgroundColor: 'gray.50',
                    color: 'black'
                },
                _active: {
                    backgroundColor: 'gray.50',
                    color: 'black'
                },
                '@supports (-webkit-appearance: none) and (stroke-color: transparent)': {
                    paddingTop: 1,
                    paddingBottom: 1
                },
                // For macOS Chrome
                '.is-mac-chrome &': {
                    paddingTop: '0',
                    paddingBottom: '0'
                }
            },
            ctaText: {
                lineHeight: '0',
                paddingTop: '0.25em',
                paddingBottom: '0.5em',
                // Safari
                ...(props?.isSafari && {
                    paddingTop: '0.55em',
                    paddingBottom: '0.20em'
                }),
                // Safari on iOS
                ...(props?.isSafari && props?.isIOS && {
                    paddingTop: '0.6em',
                    paddingBottom: '0.20em'
                }),
                // Other browsers except Safari on ioOS and macOS
                ...(((!props?.isSafari && (props?.isIOS || props?.isMacOS)) || props?.isAndroid) && {
                    paddingTop: '0.4em',
                    paddingBottom: '0.4em'
                }),
                // MacOS and Chrome
                ...(props?.isMacOSChrome && {
                    paddingTop: '0.5em',
                    paddingBottom: '0.36em'
                })
            }
        })
    }
}
